import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AmtlichebewertungNeskoService, GbGemeindeId, NeskoAbDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { EMPTY, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { catchError } from 'rxjs/operators';
import { CapAlertService } from 'app/core/extension/exceptions/cap-alert.service';
import { CapAlertLevel } from '../core/extension/exceptions/cap-alert-level.enum';

@Injectable()
export class NeskoabDetailResolver {
  gemeindeId: GbGemeindeId;
  grundstueckNummer: string;
  grundstueckNummerZusatz: string;
  grundstueckNummer3: string;

  readonly GEMEINDE_ID_PARAMETER_NAME = 'gemeindeId';
  readonly GRUNDSTUECK_NUMMER_PARAMETER_NAME = 'nummer';
  readonly GRUNDSTUECK_NUMMER2_PARAMETER_NAME = 'nummer2';
  readonly GRUNDSTUECK_NUMMER3_PARAMETER_NAME = 'nummer3';

  constructor(
    private neskoAbService: AmtlichebewertungNeskoService,
    private translate: TranslateService,
    private capAlertService: CapAlertService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<NeskoAbDetailEntryMeta> {
    this.gemeindeId = this.getGemeindeId(route.queryParamMap.get(this.GEMEINDE_ID_PARAMETER_NAME));
    this.grundstueckNummer = route.queryParamMap.get(this.GRUNDSTUECK_NUMMER_PARAMETER_NAME);
    this.grundstueckNummerZusatz = route.queryParamMap.get(this.GRUNDSTUECK_NUMMER2_PARAMETER_NAME);
    this.grundstueckNummer3 = route.queryParamMap.get(this.GRUNDSTUECK_NUMMER3_PARAMETER_NAME);

    return this.loadData();
  }

  handleError(err): Observable<any> {
    if (err.status === 502) {
      this.capAlertService.warning(this.translate.instant('neskoab.nichtVerfuegbar'), CapAlertLevel.CONTENT_HEADER);
      return EMPTY;
    } else if (err.status === 404) {
      this.capAlertService.info(this.translate.instant('KeineResultateGefunden'));
    }
    return EMPTY;
  }

  getGemeindeId(id: string): GbGemeindeId {
    return { id };
  }

  private loadData(): Observable<NeskoAbDetailEntryMeta> {
    if (!this.gemeindeId) {
      return;
    }

    return this.neskoAbService
      .loadSichtByGrundstueckNummer(
        this.gemeindeId ? this.gemeindeId.id : null, //
        this.grundstueckNummer, //
        this.grundstueckNummerZusatz,
        this.grundstueckNummer3, //
        null, //
        this.translate.currentLang
      )
      .pipe(catchError((err) => this.handleError(err)));
  }
}
